<template>
    <div>
      <van-nav-bar 
      :title="navTitle" 
      left-text="" 
      left-arrow 
      @click-left="onClickLeft" />
        <div id="prviewArea">
      
           <div id="canvas3d"  height="320px" ></div>

        </div> 

        <div style="margin-top:30px;text-align:center;">
             <van-row>
          <van-col span="6"><span >本体直径</span></van-col>
          <van-col span="10">
            <van-slider
              v-model="diameter"
              active-color="#3ea5b9"
              :min="50"
              :max="800"
              :step="5"
              @input="updateGraphs"
            >
              <template #button>
                <div class="custom-button">{{ diameter }}</div>
              </template>
            </van-slider>
          </van-col>
          <van-col span="8"
            ><van-stepper v-model="diameter" :min="50" :max="800" :step="5" @input="updateGraphs"
          /></van-col>
        </van-row>
        <van-row>
          <van-col span="6"><span >对应角度</span></van-col>
          <van-col span="10">
            <van-slider
              v-model="theta"
              active-color="#3ea5b9"
              :min="45"
              :max="135"
              :step="5"
              @input="updateGraphs"
            >
              <template #button>
                <div class="custom-button">{{ theta }}</div>
              </template>
            </van-slider>
          </van-col>
          <van-col span="8"
            ><van-stepper v-model="theta" :min="45" :max="135" :step="5"
            @input="updateGraphs"
          /></van-col>
        </van-row>
        <van-row>
          <van-col span="6"><span >跑道宽度</span></van-col>
          <van-col span="10">
            <van-slider
              v-model="width0"
              active-color="#3ea5b9"
              :min="10"
              :max="50"
              :step="5"
              @input="updateGraphs"
            >
              <template #button>
                <div class="custom-button">{{ width0 }}</div>
              </template>
            </van-slider>
          </van-col>
          <van-col span="8"
            ><van-stepper v-model="width0" :min="10" :max="50" :step="5"
            @input="updateGraphs"
          /></van-col>
        </van-row>

        <van-row>
          <van-col span="6"><span >变径尺寸</span></van-col>
          <van-col span="10">
            <van-slider
              v-model="width"
              active-color="#3ea5b9"
              :min="10"
              :max="150"
              :step="5"
              @input="updateGraphs"
            >
              <template #button>
                <div class="custom-button">{{ width }}</div>
              </template>
            </van-slider>
          </van-col>
          <van-col span="8"
            ><van-stepper v-model="width" :min="10" :max="150" :step="5"
            @input="updateGraphs"
          /></van-col>
        </van-row>
        <van-row>
          <van-col span="6"><span >跑道倾角</span></van-col>
          <van-col span="10">
            <van-slider
              v-model="w_theta"
              active-color="#3ea5b9"
              :min="0"
              :max="30"
              :step="5"
              @input="updateGraphs"
            >
              <template #button>
                <div class="custom-button">{{ w_theta }}</div>
              </template>
            </van-slider>
          </van-col>
          <van-col span="8"
            ><van-stepper v-model="w_theta" :min="0" :max="30" :step="5"
            @input="updateGraphs"
          /></van-col>
        </van-row>
        <van-row >
          <van-col span="6"><span >下降角度</span></van-col>
          <van-col span="10">
            <van-slider
              v-model="decrease"
              active-color="#3ea5b9"
              :min="0"
              :max="50"
              :step="5"
              @input="updateGraphs"
            >
              <template #button>
                <div class="custom-button">{{ decrease }}</div>
              </template>
            </van-slider>
          </van-col>
          <van-col span="8"
            ><van-stepper v-model="decrease" :min="0" :max="50" :step="5"
            @input="updateGraphs"
          /></van-col>
        </van-row>
        <van-row>
         <van-radio-group v-model="thDirect"  direction="horizontal" @change="updateGraphs">
        <van-col span="6">方向</van-col>
       
        <van-col span="9">
            <van-radio name="-1">逆时针</van-radio>
        </van-col>
        <van-col span="9">
            <van-radio name="1">顺时针</van-radio>
        </van-col>
        </van-radio-group>
      </van-row>

        <van-row type="flex" justify="end">
          <van-col span="6">
            <van-button type="warning" size="small" @click="saveSurface"
            >保存</van-button
          >
          </van-col>
          <van-col span="6">
            <van-button type="info" size="small" @click="showDownload('dxf')"
              >下载2D图纸</van-button
            >
          </van-col>
          <van-col span="6">
            <van-button type="info" size="small" @click="showDownload('cnc')"
              >下载数控代码</van-button
            >
          </van-col>
        </van-row>
        </div>

        <van-popup v-model="showDownRename" closeable position="bottom" :style="{ height: '30%' }" @closed="closeDownRenameBox">
        <div style="padding-top:15%">

          <div>
            <van-field
              v-model="userDefineName"
              center
              label="请输入项目名称"
              maxlength=80
              label-width="8em"
              required
            >
              <template #button>
                <van-button size="small" type="primary" @click="download()"  >直接下载</van-button>
              </template>
            </van-field>
            <van-field
            v-model="email"
            center
            label="输入邮箱地址"
            maxlength=80
            label-width="8em"
            :error-message="emailErrmsg"
          >
            <template #button>
              <van-button size="small" type="primary" @click="sendMail()">邮箱发送</van-button>
            </template>
          </van-field>
          </div>

        </div>
     </van-popup>
     <SurfaceForm app_type="variety" :show="surface_new_show" v-on:done="add_surface_done" v-on:close="close_surface_form" ></SurfaceForm>
    </div>
</template>
<script>
import Vue from "vue";
import {
  Col,
  Row,
  Slider,
  Stepper,
  Image as VanImage,
  Button,
  Toast,
  Swipe,
  SwipeItem,
  Checkbox,
  CheckboxGroup,
  Popup,
  Field,
  RadioGroup,
  Radio,
  NavBar
} from "vant";
import * as THREE from "three";
import { ParametricGeometry } from "three/examples/jsm/geometries/ParametricGeometry";
//import { OrbitControls } from '../libs/js/OrbitControls'
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader";
import { DragControls } from "three/examples/jsm/controls/DragControls";
import { TransformControls } from "three/examples/jsm/controls/TransformControls";
import { RoomEnvironment } from "three/examples/jsm/environments/RoomEnvironment";
import VueCookies from "vue-cookies";
import { Base64 } from "js-base64";
import { Loading } from "vant";
import LoginBox from "@/libs/LoginBox";
import BrowserInfo from "@/libs/Browserinfo";
import Clipboard from "clipboard";
import Commons from '@/libs/Commons'
import SurfaceForm from '@/components/SurfaceForm'
import { calculateVarietyCurveParams, calculatePointsZ, getOptimalSegments } from '@/libs/CurveMath'
import { debounce } from 'lodash'


Vue.use(NavBar);

Vue.use(Loading);
Vue.use(VueCookies);
Vue.use(Col);
Vue.use(Slider);
Vue.use(Row);
Vue.use(Stepper);
Vue.use(Button);
Vue.use(VanImage);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Radio);
Vue.use(RadioGroup);

export default {
    components: {
        SurfaceForm,
    },
    data() {
        return {
          //对应角度
            theta: 90,
            //本体直径
            diameter: 300,
            //道宽
            width0: 15,
            //变径尺寸
            width: 50,
            scene: null,
            camera: null,
            renderer: null,
            controls: null,
            graphMeshs: [],
            sufaceLines: [],
            showDownRename: false,
            email:"",
            userDefineName:'默认',
            downType: '',
            //方向
            thDirect: '-1' ,
            showContactUs: false,
            //邮箱提示
            emailErrmsg: '',
            //跑道倾角
            w_theta:0,
            //下降距离
            decrease: 0,

            surface_new_show: false,

            navTitle: "变径-新增",


        }
    },
    methods: {
        resetCameraView() {
            this.camera.position.x = 0;
            this.camera.position.z = 7000;
            this.camera.position.y = 0;
            this.controls.target = new THREE.Vector3(0,0,0)
            this.camera.zoom = 1
            this.camera.updateProjectionMatrix()
        },
        // 使用防抖技术减少重绘次数
        updateGraphs: debounce(function() {
            if (this.scene != null) {
                this.drawGraphs()
            }
        }, 100),
        
        // 清空之前的图形
        clearPreviousGraphs() {
            while(this.graphMeshs.length > 0) {
                var mesh = this.graphMeshs.pop()
                this.scene.remove(mesh)
            }
        },
        drawGraphs() {
            // 计算曲线参数
            const params = {
                diameter: this.diameter,
                theta: this.theta,
                width0: this.width0,
                width: this.width,
                w_theta: this.w_theta,
                decrease: this.decrease,
                thDirect: this.thDirect
            }
            
            const curveParams = calculateVarietyCurveParams(params)
            const n = getOptimalSegments()
            
            // 使用curveParams中的值
            const { direction, radius, thetaRad, adjustedWidth0, X1, Y1, Xa, Ya, X2, Y2, Xb, Yb, Bxa, Bya, Bxb, Byb, Bx1, By1, Bx2, By2, wThetaRad, decreaseRad } = curveParams
            
            // 清空之前的图形
            this.clearPreviousGraphs()
            
            // 绘制本体圆
            this.drawBaseCircle(radius)
            
            // 绘制跑道圆
            this.drawRunwayCircle(radius, adjustedWidth0, direction, thetaRad, n)
            // 绘制贝塞尔曲线
            const { bezierPoints2, bezierPoints } = this.drawBezierCurves(
                Xa, Ya, Xb, Yb, Bxa, Bya, Bxb, Byb, X1, Y1, X2, Y2, Bx1, By1, Bx2, By2, n
            )
            
            // 计算z坐标
            const { points1, points2 } = calculatePointsZ({
                points1: bezierPoints2,
                points2: bezierPoints,
                radius,
                decreaseRad,
                wThetaRad,
                n
            })
            
            // 绘制曲面
            this.drawSurface(points1, points2, n)
            
            // 绘制辅助线
            this.drawAuxiliaryLines(radius, thetaRad, X1, Y1, Xa, Ya, X2, Y2, Xb, Yb)


            

        },
        initTree() {
            this.scene = new THREE.Scene();
            let width = window.innerWidth // 窗口宽度
            let height = 320
            //this.camera = new THREE.OrthographicCamera( window.innerWidth/-2, window.innerWidth/2, window.innerHeight/2, window.innerHeight/-2, 1, 10000 );
			this.camera = new THREE.OrthographicCamera( width / - 2, width / 2, height / 2, height / - 2,  1, 10000 )
            this.camera.position.z = 7000;
            this.camera.up = new THREE.Vector3(0,0,1);
            this.camera.lookAt({x:0,y:1,z:0});

			const ambientLight = new THREE.AmbientLight(0x666666);
			this.scene.add(ambientLight);

			const DirLight = new THREE.DirectionalLight(0xffffff,1);
			this.scene.add(DirLight);
	

			this.renderer = new THREE.WebGLRenderer();
			this.renderer.setSize( width, height);
			this.renderer.setClearColor(0xaaaaaa);

			document.getElementById('canvas3d').appendChild(this.renderer.domElement) // body元素中插入canvas对象

			this.controls = new OrbitControls( this.camera, this.renderer.domElement );
			//const controls = new THREE.TrackballControls( camera, renderer.domElement );
        //    this.controls.enableRotate  = false
      this.controls.mouseButtons = {
        LEFT: THREE.MOUSE.ROTATE,
        MIDDLE: THREE.MOUSE.DOLLY,
        RIGHT: THREE.MOUSE.PAN
        }

        const axesHelper = new THREE.AxesHelper( 30 );
        this.scene.add( axesHelper );
        },
        animate() {
			requestAnimationFrame( this.animate );
			this.renderer.render( this.scene, this.camera );
			this.controls.update();
		},
    showContactUsBox() {
      
      //let box = new LoginBox()
      this.showContactUs = true
    },
     download() {
          console.log("download ", this.downType)
          if ('cnc' == this.downType) {
              this.downLoadCnc('direct')
          } else {
              this.downLoadDxf('direct')
          }
      },
            //邮箱发送
    sendMail() {
      let vue = this

      if (vue.userDefineName == "") {
        console.log("project name is empty ,not allowed download")
        vue.downloadErrMsg = "请输入项目名称"
        return ;
      }
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (vue.email == "" || !regEmail.test(vue.email)) {
        vue.emailErrmsg = "请输入正确的邮箱地址"
        return ;
      }
      localStorage.setItem("email", vue.email);
      vue.emailErrmsg = ""
      vue.downloadErrMsg = ""
      if ('cnc' == this.downType) {
          this.downLoadCnc('email')
      } else {
          this.downLoadDxf('email')
      }
      vue.$trackEvent("email", this.downType, vue.email, vue.userDefineName)
    },
    sendMailFile(url, data) {
      let vue = this
      data.email = vue.email;
      vue.$axios.post(url,data).then((res) => {
          Toast.success({message: res.data.message, onClose: ()=>{vue.showDownRename = false}})
        
      }, (e) => {
         console.log(e)
      });
    },
     downloadFile(url,  data) {
        var vue = this
        vue.$axios.post(url,data).then((res) => {
            console.log(res)
            if (window.navigator.msSaveBlob) {
            //IE以及IE内核的浏览器
            try {
                window.navigator.msSaveBlob(res.data, data.name); //response为接口返回数据，这里请求的时候已经处理了，如果没处理需要在此之前自行处理var data = new Blob([response.data]) 注意这里需要是数组形式的,fileNm就是下载之后的文件名
                // window.navigator.msSaveOrOpenBlob(response, fileNm);	//此方法类似上面的方法，区别可自行百度
            } catch (e) {console.log("down error", e)}
            } else {
            //在headers中截取filename
            var filename = data.name;
            var blob = new Blob([res.data], {type: "application/octet-stream"})
            var downloadElement = document.createElement('a');
            var href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = filename 
            //此处也可以将filename写死 "filename.xlsx"
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象 
            }
        });
        }, 
        /**
         * 下载相关
         */
        showDownload(type) {
            var vue = this
            if (!Commons.isLogin()) {
              //没有登录
              this.$dialog.confirm({title:'该操作需要先登陆', message: "是否前往登录?"})
                  .then(()=> {
                    Commons.goLogin(vue)
                    console.log('go login')
                  })

              return ;
            }
            this.downType = type
            this.showDownRename = true
            
        },
        closeDownRenameBox() {
        this.showDownRename = false
        },
        downLoadDxf(type) {
        var url = '';
        url = this.$url + '/v2/surface/dxf'
        var vue = this
        var param = {
            "line1": vue.sufaceLines[0],
            "line2": vue.sufaceLines[1],

        };
        let data = {
            "name": this.currentDate + "_"+ this.userDefineName + ".dxf",
            "params":param
        }
        if ('email' == type) {
           this.sendMailFile(url, data);
        } else {
          this.downloadFile(url, data);
        }
        },
        downLoadCnc(type) {
        var url = '';
        url = this.$url + '/v2/surface/cnc'
        var vue = this
        var param = {
            "line1": vue.sufaceLines[0],
            "line2": vue.sufaceLines[1],

        };
        let data = {
            "name": this.currentDate + "_"+ this.userDefineName + ".cnc",
            "params":param
        }
        if ('email' == type) {
           this.sendMailFile(url, data);
        } else {
          this.downloadFile(url, data);
        }
        
        },
        saveSurface() {
          var vue = this
          if (!Commons.isLogin()) {
            //没有登录
            this.$dialog.confirm({title:'该操作需要先登陆', message: "是否前往登录?"})
                .then(()=> {
                  Commons.goLogin(vue)
                  console.log('go login')
                })

            return ;
          }
            if (this.id == 'new') {
               this.surface_new_show = true
            } else {
              //保存
              this.saveSurfaceParam(this.id)
            }
        },
        async add_surface_done(n_id) {
          this.id = n_id      
          this.saveSurfaceParam(n_id)
          this.surface_new_show = false
       },
        close_surface_form() {
          this.surface_new_show = false
        },
        async getSurfaceParam(id) {
            if (id == 'new') {
              return 
            }
            let resp = await Commons.getSurface(this, id)
            let params = Commons.getAppParams(this, 'variety', id, resp)
            if (params ) {
                this.navTitle = '变径-【' + resp.name+"】"
                for (var i in params[0]) {
                  console.log('setting', i, params[0][i])
                  this.$set(this, i, params[0][i])
                }
            }
            
        },
      async saveSurfaceParam(id) {
            //调用保存
            let params = {
              "params": [{
                //对应角度
                theta: this.theta ,
                //本体直径
                diameter: this.diameter,
                //道宽
                width0: this. width0,
                //变径尺寸
                width: this.width,
                thDirect: this.thDirect,
                //跑道倾角
                w_theta: this.w_theta,
                //下降距离
                decrease: this.decrease
              }]
          }

            let resp = await Commons.updateSurface(this, id, params)
            if (resp.code =='ok') {
               Toast.success("保存成功")
            }
        },
        onClickLeft() {
          this.$router.back()
        }
    },
    mounted() {
        this.id = this.$route.params.id
        this.getSurfaceParam(this.id)
        this.initTree()
        this.updateGraphs()
        this.animate()
        this.email = localStorage.getItem("email")
        
    },
    computed:  {
        currentDate: function() {
        var date = new Date();
        return date.getFullYear() + "-" + (date.getMonth()  + 1 )+ "-" + date.getDate()
      }
    }
}
</script>

<style scoped>
#prviewArea {
  height: 300px;
  width: 100%;
}
.custom-button {
  width: 26px;
  color: #fff;
  font-size: 10px;
  line-height: 18px;
  text-align: center;
  background-color: #3ea5b9;
  border-radius: 100px;
}
#footer {
  padding-top: 20px;
  min-height: 320px;
}
.van-row {
  padding-top: 20px;
}
.van-image {
  display: flex;
  align-items: center;
}
.van-slider {
  margin-top: 13px;
}
.resetCameraBnt {
    position: absolute;
    top: 260px;
    right: 20px;
}
.showtrack-label {
    height: 30px;
}
.showtrack-label /deep/ .van-checkbox__label {
    color: rgb(22, 143, 199);
    height: 20px;
}
.contactUsBnt {
  text-align: center;
}
.contactUsBox /deep/.van-dialog__content {
    display: flex;
    justify-content: center;
  }
</style>
